export const ApplicationRoutes = {
  register: '/register',
  resetPassword: '/resetPassword',
  member: '/member',
  upgrade: '/upgrade',
  home: '/'
}

export default ApplicationRoutes;
